import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseFormControl } from '../components/base-form-control/Component.js';
import 'classnames';
import '../../../shared/esm';

var defaultColors = {"inner":"form-control__inner_zffu3","disabled":"form-control__disabled_zffu3","hasError":"form-control__hasError_zffu3"};
require('./default.desktop.css');

var styles = {"above":"form-control__above_1ibcz","sub":"form-control__sub_1ibcz","error":"form-control__error_1ibcz","s":"form-control__s_1ibcz","inner":"form-control__inner_1ibcz","m":"form-control__m_1ibcz","l":"form-control__l_1ibcz","xl":"form-control__xl_1ibcz"};
require('./desktop.css');

var invertedColors = {"inner":"form-control__inner_ayn52","disabled":"form-control__disabled_ayn52","hasError":"form-control__hasError_ayn52"};
require('./inverted.desktop.css');

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var FormControlDesktop = forwardRef(function (restProps, ref) { return (React.createElement(BaseFormControl, __assign({}, restProps, { ref: ref, styles: styles, colorStyles: colorStyles }))); });

export { FormControlDesktop };
